const o = (e, t = document.documentElement) => getComputedStyle(t).getPropertyValue(e);
export {
  o as getComputedStyleValue
};
